<app-privacy-policy-it *ngIf="global.culture == 'it'"></app-privacy-policy-it>
<app-privacy-policy-en *ngIf="global.culture == 'en'"></app-privacy-policy-en>
<app-privacy-policy-es *ngIf="global.culture == 'es'"></app-privacy-policy-es>
<app-privacy-policy-fr *ngIf="global.culture == 'fr'"></app-privacy-policy-fr>
<div class="block-space block-space--layout--divider-nl"></div>